import { z } from 'zod';
export const ProspectPointSchema = z.object({ lat: z.number().min(-90).max(90), lng: z.number().min(-180).max(180) });
export const ProspectSearchSchema = z.object({
    query: z.string().trim().max(120).default(''),
    address: z.string().trim().max(200).default(''),
    center: ProspectPointSchema.optional(),
    radius: z.number().int().min(100).max(50000).default(1500),
    type: z.string().regex(/^[a-z_]{1,50}$/).optional(),
    pageToken: z.string().min(1).max(2000).optional(),
}).refine(value => value.center || value.address.length >= 2 || value.query.length >= 2 || value.pageToken, 'Enter a location or business name.');
export const ProspectSchema = z.object({
    placeId: z.string().min(1), name: z.string(), address: z.string(),
    location: ProspectPointSchema.nullable(), types: z.array(z.string()),
    rating: z.number().nullable(), reviewCount: z.number().nullable(),
    harvestedAt: z.string().nullable(), website: z.string().nullable(),
});
export const ProspectSearchResultSchema = z.object({
    hits: z.array(ProspectSchema), center: ProspectPointSchema.nullable(), nextPageToken: z.string().nullable(),
});
export const ProspectHarvestsSchema = z.object({ hits: z.array(ProspectSchema), nextCursor: z.string().nullable() });
export const ProspectHarvestRequestSchema = z.object({ placeId: z.string().min(1).max(200).regex(/^[a-zA-Z0-9_-]+$/) });
export const ProspectHarvestResultSchema = z.object({
    placeId: z.string(), name: z.string(), photoCount: z.number(), reviewCount: z.number(),
    hasMenu: z.boolean(), hasWebsite: z.boolean(), state: z.enum(['full', 'partial']),
});
export const ProspectHarvestPhotoSchema = z.object({
    id: z.string(), filename: z.string(), category: z.string(), downloadAvailable: z.boolean(),
});
/** Cached source evidence, with credential-bearing fields and URL parameters redacted. */
export const ProspectHarvestDetailSchema = z.object({
    prospect: ProspectSchema,
    data: z.record(z.unknown()),
    collections: z.record(z.array(z.object({ id: z.string(), data: z.record(z.unknown()) }))),
    photos: z.array(ProspectHarvestPhotoSchema),
    photoDownloadsConfigured: z.boolean(),
    exportedAt: z.string(),
});
